import { render, staticRenderFns } from "./InputForm.vue?vue&type=template&id=6ce07c71&scoped=true&"
import script from "./InputForm.vue?vue&type=script&lang=js&"
export * from "./InputForm.vue?vue&type=script&lang=js&"
import style0 from "./InputForm.vue?vue&type=style&index=0&id=6ce07c71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce07c71",
  null
  
)

export default component.exports